import React from "react";
import AppRouter from "./router/Router";
import "./App.css";

function App() {
  return (
    <div className="App mobile-view">
      <AppRouter />
    </div>
  );
}

export default App;
